/**
 * close-code.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

// TODO: It turns out this exact enum exists on the backend. Might as well sync
// up the names to prevent confusion.
export enum CloseCode {
    // From https://tools.ietf.org/html/rfc6455#section-7.4
    // (with additional name suggestions from MDN)
    Normal            = 1000,
    GoingAway         = 1001,
    ProtocolError     = 1002,
    Unsupported       = 1003,
    // 1004 is reserved
    NoStatus          = 1005, // NOTE: This is never present in a close frame
    Abnormal          = 1006,
    UnsupportedData   = 1007,
    PolicyViolation   = 1008,
    TooLarge          = 1009,
    MissingExtension  = 1010,
    InternalError     = 1011,
    ServiceRestart    = 1012,
    TryAgainLater     = 1013,
    // 1014 is reserved
    TLSFailure        = 1015,
    // 1016-2999 is reserved for future protocol
    // 3000-3999 is reserved for libraries/frameworks
    // 4000-4999 is private use area to remain undefined
    LocalFailure      = 4000
}

// The values returned by WebSocket.readyState
export enum ReadyState {
    Connecting = 0,
    Open,
    Closing,
    Closed
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/connection/enums.ts